<template>
  <div>
    <b-row class="mb-1">
      <!-- Email Settings -->
      <b-col md="6">
        <b-card class="h-100">
          <h5 class="font-weight-bolder mb-2">Email Settings</h5>

          <!-- SMTP Host -->
          <b-form-group>
            <label class="font-weight-bold">SMTP Host</label>
            <b-form-input v-model="form.smtpHost" />
          </b-form-group>

          <!-- SMTP Port -->
          <b-form-group>
            <label class="font-weight-bold">SMTP Port</label>
            <b-form-input v-model="form.smtpPort" />
          </b-form-group>

          <!-- From Email -->
          <b-form-group>
            <label class="font-weight-bold">From Email</label>
            <b-form-input v-model="form.fromEmail" />
          </b-form-group>

          <!-- From Name -->
          <b-form-group>
            <label class="font-weight-bold">From Name</label>
            <b-form-input v-model="form.fromName" />
          </b-form-group>

          <!-- Enable Email Notifications -->
          <b-form-group>
            <label class="font-weight-bold">Enable Email Notifications</label>
            <div class="d-flex align-items-center justify-content-between">
              <span class="small text-muted"
                >Allow email notifications to be sent</span
              >
              <b-form-checkbox v-model="form.enableEmail" switch />
            </div>
          </b-form-group>
        </b-card>
      </b-col>

      <!-- Notification Preferences -->
      <b-col md="6">
        <b-card class="h-100">
          <h5 class="font-weight-bolder mb-2">Notification Preferences</h5>

          <!-- Marketing Emails -->
          <div class="d-flex align-items-center justify-content-between mb-1">
            <div>
              <p class="font-weight-bolder mb-0">Marketing Emails</p>
              <span class="small text-muted"
                >Promotional and marketing communications</span
              >
            </div>
            <b-form-checkbox v-model="form.marketingEmails" switch />
          </div>

          <!-- Transaction Notifications -->
          <div class="d-flex align-items-center justify-content-between mb-1">
            <div>
              <p class="font-weight-bolder mb-0">Transaction Notifications</p>
              <span class="small text-muted"
                >Deposits, withdrawals, and account changes</span
              >
            </div>
            <b-form-checkbox v-model="form.transactionNotifications" switch />
          </div>

          <!-- Security Alerts -->
          <div class="d-flex align-items-center justify-content-between mb-1">
            <div>
              <p class="font-weight-bolder mb-0">Security Alerts</p>
              <span class="small text-muted"
                >Login alerts and security notifications</span
              >
            </div>
            <b-form-checkbox v-model="form.securityAlerts" switch />
          </div>

          <!-- System Updates -->
          <div class="d-flex align-items-center justify-content-between mb-1">
            <div>
              <p class="font-weight-bolder mb-0">System Updates</p>
              <span class="small text-muted"
                >Maintenance and system status updates</span
              >
            </div>
            <b-form-checkbox v-model="form.systemUpdates" switch />
          </div>

          <!-- Max Daily Emails -->
          <b-form-group>
            <label class="font-weight-bold">Max Daily Emails per User</label>
            <b-form-input v-model="form.maxEmails" number type="number" />
          </b-form-group>
        </b-card>
      </b-col>
    </b-row>

    <!-- Save Button -->
    <b-card>
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="text-body font-weight-bolder">Save Changes</h5>
        <b-button variant="success">
          <feather-icon icon="SaveIcon" />
          Save All Settings
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BButton,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
  },
  data() {
    return {
      form: {
        smtpHost: "smtp.gmail.com",
        smtpPort: "587",
        fromEmail: "noreply@upc.com.au",
        fromName: "UPC Betting Platform",
        enableEmail: true,

        marketingEmails: true,
        transactionNotifications: true,
        securityAlerts: true,
        systemUpdates: false,
        maxEmails: 10,
      },
    };
  },
};
</script>
